import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";
import storage from "../../Assets/js/Global";
import { images } from "../../Assets/images";

const Login = () => {
  const {
    checkUserRegistration,
    userData,
    updateUserData,
    translatedLabels,
    logoUrl,
    is4Life,
    fourLifeSSOLogin
  } = useContext(GlobalContext);

  const authLabel = translatedLabels?.auth;
  const [showEmailInput, setShowEmailInput] = useState(!is4Life);

  function loginWithGoogle() {
    window?.ReactNativeWebView?.postMessage("googleSignIn");
  }

  function loginWithApple() {
    window?.ReactNativeWebView?.postMessage("appleSignIn");
  }

  useEffect(() => {
    storage.remove("UserModule");
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    checkUserRegistration();
  };

  // const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <section id="loginPage" className="login-section-bg">
      <div className="container-main">
        <div className="d-flex justify-content-center">
          <div className="app-logo">
            <img
              src={logoUrl || images.appLogo}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <h3 className="mt-3 mb-0 text-center">
          {authLabel?.welcome_back?.label_value || "Welcome Back!"}
        </h3>

        {is4Life && !showEmailInput ? (
          <div className="mt-4 pt-2 d-grid gap-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={fourLifeSSOLogin}
            >
              {authLabel?.already_4life_member?.label_value || "Continue with your 4Life account"}
            </button>
            {/* <Link
              to="/qr-scanner"
              className="btn text-muted"
            >
              {authLabel?.already_4life_member?.label_value ||
                "Already 4Life Member"}
            </Link>
            <Link to="/qr-scanner" className="btn text-muted">
              {authLabel?.continue_as_guest?.label_value || "Continue as Guest"}
            </Link> */}
          </div>
        ) : (
          <>
            <form className="login-form" onSubmit={handleSubmit}>
              {/* {is4Life && showEmailInput && (
                <div className="mb-3">
                  <span
                    className="text-muted cursor-pointer d-flex align-items-center"
                    onClick={() => setShowEmailInput(false)}
                    style={{ fontSize: '14px' }}
                  >
                    <i className="fa fa-arrow-left me-2"></i>
                    {authLabel?.back?.label_value || "Back"}
                  </span>
                </div>
              )} */}
              <div className="mb-4">
                <label className="form-label">
                  {authLabel?.login_signup?.label_value || "Login / Signup"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder={
                    authLabel?.enter_your_email?.label_value ||
                    "Enter your email"
                  }
                  value={userData.email}
                  onChange={(e) => updateUserData("email", e.target.value)}
                />
              </div>

              <div className="mt-4 text-center">
                <button type="submit" className="btn btn-primary">
                  {authLabel?.next?.label_value || "Next"}
                </button>
              </div>

              {/* {!is4Life && (
                <div className="mt-3 text-center">
                  <Link
                    to="/qr-scanner"
                    className="btn btn-link text-decoration-none text-muted"
                  >
                    <i className="fa fa-qrcode me-2"></i>
                    Scan QR Code
                  </Link>
                </div>
              )} */}
            </form>

            {!is4Life && (
              <>
                <div style={{ padding: "28px 0px" }} className="">
                  <hr />
                  <h6
                    className="mb-0 text-center"
                    style={{ marginTop: "-27px" }}
                  >
                    <span className="bg-white d-inline-block px-2 position-relative text-muted">
                      {authLabel?.or?.label_value || "OR"}
                    </span>
                  </h6>
                </div>

                <div className="social-login d-flex justify-content-center">
                  <div className="app-button mx-2" onClick={loginWithGoogle}>
                    <img
                      className="me-1"
                      src={images.googleIcon}
                      style={{ width: "18px" }}
                      alt="Google"
                    />
                    {authLabel?.google?.label_value || "Google"}
                  </div>

                  {isIOS && (
                    <div className="app-button mx-2" onClick={loginWithApple}>
                      <img
                        className="me-1"
                        src={images.appleIcon}
                        style={{ width: "18px" }}
                        alt="Apple"
                      />
                      {authLabel?.apple?.label_value || "Apple"}
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Login;
